import {
    IcApkWebBtn,
    IcTFWebBtn,
    IcApkMobileMainBtn,
    IcTFMobileMainBtn,
    IcDownAppStore,
    IcDownAppStore2,
    IcDownAppStoreMobile,
    IcDownGoogleStore,
    IcDownGoogleStoreMobile,
    IcG1cashLogo,
    IcG1cashText,
} from "../../constants/icons";
import iosIntroSrc from "../../assets/images/ios-g1cash-intro.png";
import iosHomeSrc from "../../assets/images/ios-g1cash-home.png";
import icFirstBg from "../../assets/images/ic-firstpage-bg.png";
import Qrcode from "../Qrcode/Qrcode";
import "./firstpage.css";
import { alertComming, downloadApk, onClickAppDownLink } from "../../utility/utility";

const FirstPage = () => {
    return (
        <div className="first-page">
            <img className="first-page-bg" src={icFirstBg} />
            <div className="first-top">
                <IcG1cashLogo className="first-top-logo" />
                <IcG1cashText className="first-top-text" />
            </div>
            <div className="first-body">
                <div className="first-body-left">
                    <img src={iosHomeSrc} className="first-body-home" />
                    <img src={iosIntroSrc} className="first-body-intro" />
                </div>
                <div className="first-body-right">
                    <div className="first-body-title title">
                        {"The ultimate\n"}
                        <span>investing platform</span>
                        {" for\n"}
                        <span>achieving greater</span>
                        {"\nfinancial stability"}
                    </div>
                    <div className="first-body-qr">
                        {/* <QrInfo/> */}
                    {/* <IcApkWebBtn onClick={downloadApk} /> */}
                        
                        <div>
                            <IcDownGoogleStore />
                            <Qrcode type="googlestore" />
                        </div>
                        <div>
                            <IcDownAppStore />
                            {/* <div className="qr">
                                <IcDownAppStore2 onClick={alertComming} />
                            </div> */}
                            <Qrcode type="appstore" />
                        </div>
                    </div>
                    {/* <span className="info-message web">* apk를 다운받은 사용자는 삭제 후 다시 다운받아주세요.</span> */}

                    <div className="first-body-btn">
                    {/* <IcApkMobileMainBtn onClick={downloadApk} /> */}
                        {/* <IcTFMobileMainBtn onClick={alertComming} /> */}
                        <IcDownGoogleStoreMobile onClick={() => onClickAppDownLink("googlestore")} />
                        <IcDownAppStoreMobile onClick={() => onClickAppDownLink("appstore")} />
                        {/* <IcDownAppStoreMobile onClick={alertComming} /> */}
                    </div>
                    {/* <span className="info-message mobile">* apk를 다운받은 사용자는 삭제 후 다시 다운받아주세요.</span> */}
                </div>
            </div>
        </div>
    );
};

export default FirstPage;
